<template>
  <div class="drawer-wrapper">
    <CustomerContactSidebar />
    <div class="customer-contact-wrap">
      <!-- <h1 class="customer-contact-title">{{ customer.name }}</h1> -->
      <div class="customer-contact-detail">
        <CustomerContactInfo />
      </div>
    </div>
    <router-view class="content" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CustomerContactSidebar from "./CustomerContactSidebar.vue";
import CustomerContactInfo from "./CustomerContactInfo.vue";
import _ from "lodash";

export default {
  name: "CustomerContact",
  components: {
    CustomerContactSidebar,
    CustomerContactInfo
  },
  data() {
    return {
      page: 0,
      limit: 20,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "联系人",
          minWidth: 70,
          maxWidth: 110,
          key: "title",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditTaskDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
        {
          title: "手机",
          minWidth: 70,
          key: "mobile",
          align: "left",
          render: (h, params) => h("span", params.row?.mobile),
        },
        {
          title: "部门",
          minWidth: 70,
          key: "department",
          align: "left",
          render: (h, params) => h("span", params.row?.department),
        },
        {
          title: "职位",
          minWidth: 70,
          key: "title",
          align: "left",
          render: (h, params) => h("span", params.row?.title),
        },
      ],
    }
  },
  computed: mapState({
    totalRows: (state) => state.customerContact.totalCounts,
    customerContactList: (state) => state.customerContact.customerContactList,
  }),
  methods: {
    ...mapActions({
      getUsers: "user/getUsersAction",
      getCustomerContact: "customerContact/getCustomerContactAction",
    }),
    async loadCustomerContact(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      try {
        this.tableLoading = true;
        await this.getCustomerContact(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
      }
    },
    searchCustomerContact() {},
  },
  async created() {
    this.getCustomerContact();
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
.drawer-wrapper
  display flex
  padding 0

.customer-contact-detail
  display flex

.customer-contact-title
  margin-bottom 20px
  display inline-block
  width 1200px
  padding 0 16px

.comment
  width 320px
</style>